/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {Icons as ɵa} from './lib/icons.provider';